/* ========================================================================== *\
___________       __         .__
\_   _____/ _____/  |________|__| ____
 |    __)_ /    \   __\_  __ \  |/  _ \
 |        \   |  \  |  |  | \/  (  <_> )
/_______  /___|  /__|  |__|  |__|\____/
        \/     \/
\* ========================================================================== */
// เหมือน mb_strlen(trim($prompt)): นับ Unicode code points ไม่ใช่ UTF-16 units
export default function promptLength(value) {
  const chars = Array.from(String(value || ''));
  const whitespace = [0, 9, 10, 11, 13, 32];
  let start = 0;
  let end = chars.length;
  while (start < end && whitespace.includes(chars[start].codePointAt(0))) start += 1;
  while (end > start && whitespace.includes(chars[end - 1].codePointAt(0))) end -= 1;
  return end - start;
}
